import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const SelectModeSubtractIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22 7.25H17.75V2C17.75 1.59 17.41 1.25 17 1.25H2C1.59 1.25 1.25 1.59 1.25 2V17C1.25 17.41 1.59 17.75 2 17.75H7.25V22C7.25 22.41 7.59 22.75 8 22.75H22C22.41 22.75 22.75 22.41 22.75 22V8C22.75 7.59 22.41 7.25 22 7.25ZM21.25 21.25H8.75V8.75H21.25V21.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectModeSubtractIcon.displayName = 'SelectModeSubtractIcon';
